import { isMobileEmbedView } from '@ms/yammer-web-support/dist/userAgent';
import { getVivaConnectionsAppTheme } from 'mobileEmbedView';

type IsInvertedTheme = () => boolean;
export const isInvertedTheme: IsInvertedTheme = () => {
  if (!isMobileEmbedView()) {
    //TODO: Read theme from Teams context and return whether theme is dark
    return false;
  }
  const theme = getVivaConnectionsAppTheme();
  if (theme === undefined) {
    return false;
  }

  return theme === 'dark';
};
